import React from 'react';
import { ToothViewData } from './teethData';
import DENTToothSurface from './DENTToothSurface';
import {
	Tooth,
	ToothDiscolorationType,
	ToothSurface,
} from '../../../../graphql/graphql';

interface Props {
	data: Tooth;
	toothViewData: ToothViewData;
}

const surfaceColorPerType: Record<ToothDiscolorationType, string> = {
	[ToothDiscolorationType.Red]: '#ffeaea',
	[ToothDiscolorationType.Gray]: '#e3e3e3',
	[ToothDiscolorationType.Yellow]: '#fff5d6',
};

const DENTToothDiscoloration: React.FC<Props> = ({ data, toothViewData }) => {
	const discolorationValues = data.pathology?.discoloration?.values;
	if (discolorationValues && discolorationValues.type) {
		return (
			<g opacity='0.7'>
				<DENTToothSurface
					toothViewData={toothViewData}
					surface={ToothSurface.Crown}
					color={surfaceColorPerType[discolorationValues.type]}
				/>
			</g>
		);
	}

	return <></>;
};

export default DENTToothDiscoloration;
